export default __webpack_public_path__ + "static/media/504.c0bef85d.jpg";